import styles from './EstimatedSettlement.module.scss'
import LoadingSkeleton from 'components/loading-skeleton/LoadingSkeleton.tsx'
import classNames from 'classnames'
import { formatCurrency } from 'utils/format.ts'
import { useTranslation } from 'react-i18next'
import { useGetLanguage } from 'hooks/use-get-language'
import { EstimatedSettlementProps } from './types.ts'
import { Heading } from '@boltenergy-be/design-system'
import { getSettlementColor } from 'utils/billShock.ts'

const EstimatedSettlement = ({ loading, settlementAmount, labelAsTitle, className, alwaysOneLine }: EstimatedSettlementProps) => {
  // i18n
  const { t } = useTranslation('billing')
  const language = useGetLanguage()

  return (
    <div className={classNames(styles.settlement, className)}>
      <dt>
        {labelAsTitle ? (
          <Heading as={labelAsTitle} variant="h6" serif>
            {t(($) => $.settlement.label)}
          </Heading>
        ) : (
          <strong>{t(($) => $.settlement.label)}</strong>
        )}
      </dt>

      <dd>
        {loading ? (
          <LoadingSkeleton>
            <LoadingSkeleton.Rectangle height={24} width={140} />
          </LoadingSkeleton>
        ) : typeof settlementAmount === 'number' ? (
          <strong className={classNames(getSettlementColor(settlementAmount), { [styles['one-line']]: alwaysOneLine })}>
            {formatCurrency(Math.abs(settlementAmount), { language })}{' '}
            <span className={styles['settlement-context']}>{t(($) => $.settlement[settlementAmount > 0 ? 'extra' : 'recover'])}</span>
          </strong>
        ) : (
          <strong>—</strong>
        )}
      </dd>
    </div>
  )
}

export default EstimatedSettlement
